import React, { useState, useEffect, useCallback } from 'react';
import { Shield, CheckCircle, XCircle } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../../ui/card';
import { Switch } from '../../ui/switch';
import { useAdminSettings } from '../../../hooks/useAdminSettings';

const SecurityTab = () => {
  const { apiCall } = useAdminSettings();
  const [securitySettings, setSecuritySettings] = useState({});

  const fetchSecuritySettings = useCallback(async () => {
    try {
      const data = await apiCall('get', '/api/admin/settings/security');
      setSecuritySettings(data);
    } catch (error) {
      console.error('Error fetching security settings:', error);
    }
  }, [apiCall]);

  useEffect(() => {
    fetchSecuritySettings();
  }, [fetchSecuritySettings]);

  return (
    <div className="space-y-6">
      <Card className="bg-gray-900 border-gray-800">
        <CardHeader>
          <CardTitle className="text-white">Security Configuration</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="flex items-center justify-between p-3 bg-gray-800/50 rounded-lg">
            <div>
              <p className="text-white font-medium">Require 2FA for Admins</p>
              <p className="text-sm text-gray-400">Force admins to enable two-factor authentication</p>
            </div>
            <Switch checked={securitySettings.settings?.require_2fa_for_admins ?? false} />
          </div>
          <div className="flex items-center justify-between p-3 bg-gray-800/50 rounded-lg">
            <div>
              <p className="text-white font-medium">Require 2FA for All Users</p>
              <p className="text-sm text-gray-400">Force all users to enable two-factor authentication</p>
            </div>
            <Switch checked={securitySettings.settings?.require_2fa_for_all ?? false} />
          </div>
        </CardContent>
      </Card>

      {/* Login History */}
      <Card className="bg-gray-900 border-gray-800">
        <CardHeader>
          <CardTitle className="text-white">Recent Login Activity</CardTitle>
        </CardHeader>
        <CardContent>
          {securitySettings.recent_logins?.length > 0 ? (
            <div className="space-y-2 max-h-64 overflow-y-auto">
              {securitySettings.recent_logins.slice(0, 10).map((login) => (
                <div key={login.id || `${login.timestamp}-${login.email || login.user_id}`} className="flex justify-between items-center p-2 bg-gray-800/50 rounded text-sm">
                  <span className="text-white">{login.email || login.user_id}</span>
                  <div className="flex items-center gap-2">
                    <span className="text-gray-400">{new Date(login.timestamp).toLocaleString()}</span>
                    {login.success ? (
                      <CheckCircle className="w-4 h-4 text-green-400" />
                    ) : (
                      <XCircle className="w-4 h-4 text-red-400" />
                    )}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-400 text-center py-4">No login history available</p>
          )}
        </CardContent>
      </Card>
    </div>
  );
};

export default SecurityTab;
